import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Demo from './components/Demo';
import VRTherapy from './components/VRTherapy';
import TwoVideos from './components/TwoVideos';
import Testimonials from './components/Testimonials';
import Offering from './components/Offering';
import Footer from './components/Footer';
import Growth from './components/Growth';
import TherapyModes from './components/TherapyModes';
import FeaturesVideoSection from './components/FeaturesVideoSection';
import InfoSection from './components/InfoSection';


function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Features />
      <Demo />
      <VRTherapy />
      <TwoVideos />
      <Testimonials />
      <Growth />
      <TherapyModes />
      <Offering />
      <FeaturesVideoSection />
      <InfoSection
        title="Empower Your Enterprise with VRET"
        description="Our VRET platform enables immersive corporate training experiences. Deliver safe, engaging, and interactive sessions in your institution that enhance employee skills, collaboration, and performance."
        buttonLink="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1rLxSwhVyDEIht-TrSvygW02E2G_NpddYYet6kX3V5Mf2rkdiNMtG9ZkFKW3Y7xJ0AYVSXKrCV" 
      />
      <Footer />
    </div>
  );
}

export default App;
